import React, { Component } from 'react'

import _ from 'lodash'
import moment from 'moment'
import history from '../../history'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import Loader from '../../util/Loader'
import { bindActionCreators } from 'redux'
import { Tooltip } from 'antd'
import { withRouter } from 'react-router-dom'
import { ModalRoute } from 'react-router-modal'
import { filterCaseInsensitive } from '../../util'
import { getShortcut } from '../../util/leadFollowUps'
import { actions as userActions } from '../../redux/modules/userActions'
import { actions as auditActions } from '../../redux/modules/auditActions'
import { actions as followUpActions } from '../../redux/modules/leadFunctions/leadFollowUpActions'

import AddEditFormModal from './components/followups/AddEditFormModal.component'

import * as authSelectors from '../../selectors/auth'
import * as leadFollowUpsSelectors from '../../selectors/lead/followups'

const propTypes = {}

class LeadFollowUps extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      activeKey: '1'
    }

    this.props.getUsers()
    this.props.getUserRoles()
  }

  componentDidMount() {
    this.props.leadFollowUpsRefresh({
      leadId: this.props.leadId,
      next: (err, payload) => {
        const { followUpIdParam } = this.props
        if (!err) {
          const results = _.get(payload, 'data')
          const current = _.find(results, { id: followUpIdParam })
          this.setState({
            currentId: followUpIdParam,
            contentData: current
          })
        }
      }
    })
  }

  handleRowClick = row => {
    const { leadId } = this.props
    this.props.getAuditRevisions({
      targetId: row.id,
      table: 'follow_up'
    })
    this.handleShortcutData(row)
    this.setState(
      {
        modalVisible: true,
        currentId: row.id,
        contentData: row,
        activeKey: '1'
      },
      () => {
        history.push(`/lead/${leadId}/followups/edit/${row.id}`)
      }
    )
  }

  handleAddButton = () => {
    const { leadId } = this.props
    history.push(`/lead/${leadId}/followups/add`)
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null,
      activeKey: '1'
    })
  }

  handleCancel = () => {
    const { leadId } = this.props
    history.push(`/lead/${leadId}/followups`)
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleScheduleShortcut = (scheduleId, scheduleType) => {
    this.props.navTo(scheduleId, scheduleType)
  }

  onTabChange = activeKey => {
    this.setState({ activeKey })
  }

  handleShortcut = () => {
    this.props.handleShortcut(this.state.leadFunction, this.state.shortcutId)
  }

  handleShortcutData = row => {
    const followUpShortcuts = getShortcut(row)

    this.setState({
      shortcutId: followUpShortcuts.shortcutId,
      leadFunction: followUpShortcuts.leadFunction
    })
  }

  handleRevisionChange = value => {
    const form = this.props.form
    const revisions = JSON.parse(
      this.props.auditActions.revisions.data.find(x => x.id === value).json_patch
    )

    const foundIsUser = revisions.find(revision => revision.path === '/assigned_to_id')

    const isUser = foundIsUser && Boolean(+foundIsUser.value)

    this.setState(
      {
        assignToType: isUser ? 'user' : 'role'
      },
      () => {
        let changes = {}
        revisions.forEach(revision => {
          const fieldName = revision.path.substring(1, revision.path.length)
          const isAssignedToField =
            fieldName === 'assigned_to_id' || fieldName === 'assigned_to_role_id'
          if (!_.isNil(form.getFieldsValue()[fieldName]) || isAssignedToField) {
            if (!_.isNil(revision.value)) {
              changes[fieldName] = revision.value.toString()
            }
          }
        })
        if (changes.due_date) changes.due_date = moment(changes.due_date)

        form.setFieldsValue(changes)
      }
    )
  }
  render() {
    const { contentData } = this.state
    const { leadId, followUpIdParam } = this.props

    if (!this.props.leadFollowUpActions.leadFollowUps) {
      return <Loader />
    }

    return (
      <div>
        <ModalRoute
          component={AddEditFormModal}
          props={{
            action: 'edit',
            contentData: contentData,
            handleCancel: this.handleCancel,
            leadId: leadId,
            followUpIdParam: followUpIdParam
          }}
          path={`/lead/:leadId/followups/edit/:followUpId`}
          exact
        />
        <ModalRoute
          component={AddEditFormModal}
          props={{
            action: 'add',
            handleCancel: this.handleCancel,
            leadId: leadId
          }}
          path={`/lead/:leadId/followups/add`}
          exact
        />
        <div className="jobsBar">
          Follow Ups
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;
            <div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Follow Up
            </div>
          </div>
        </div>
        {this.props.leadFollowUpActions.leadFollowUps && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTdProps={(state, rowInfo, column, instance) => ({
              onClick: e => {
                if (column.Header !== undefined) {
                  this.handleRowClick(rowInfo.original)
                }
              }
            })}
            data={this.props.leadFollowUpActions.leadFollowUps.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Type',
                    id: 'tyoe',
                    accessor: 'type',
                    Cell: d => <Tooltip title={d.original.type}>{d.original.type}</Tooltip>,
                    maxWidth: 300
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Related ID',
                    id: 'related_id',
                    accessor: d => {
                      const followUpShortcuts = getShortcut(d)
                      return followUpShortcuts.shortcutId
                    },
                    Cell: d => {
                      const followUpShortcuts = getShortcut(d.original)
                      return (
                        <Tooltip title={followUpShortcuts.shortcutId}>
                          {followUpShortcuts.shortcutId}
                        </Tooltip>
                      )
                    },
                    maxWidth: 100
                  },
                  {
                    Header: 'Assigned To',
                    id: 'assigned_to_name',
                    accessor: d =>
                      d.assigned_to_role_name
                        ? d.assigned_to_role_name
                        : `${d.assigned_to_first_name} ${d.assigned_to_last_name}`,
                    Cell: d => {
                      let r = ''
                      if (d.original.assigned_to_role_name) {
                        r = d.original.assigned_to_role_name
                      } else {
                        r = `${d.original.assigned_to_first_name} ${
                          d.original.assigned_to_last_name
                        }`
                      }
                      return <Tooltip title={r}>{r}</Tooltip>
                    },
                    maxWidth: 110
                  },
                  {
                    Header: 'Due date',
                    id: 'due_date',
                    accessor: d => moment(d.due_date).format('M/D/YYYY'),
                    maxWidth: 110
                  },
                  {
                    Header: 'Status',
                    accessor: 'status',
                    Cell: row => {
                      let color = null
                      if (row.value === 'OVERDUE') {
                        color = '#ff2e00'
                      } else if (row.value === 'Closed') {
                        color = 'gray'
                      } else {
                        if (row.value === 'Opened') {
                          color = '#ffbf00'
                        } else {
                          color = '#57d500'
                        }
                      }
                      return (
                        <span>
                          <span
                            style={{
                              color: color,
                              transition: 'all .3s ease'
                            }}
                          >
                            &#x25cf;
                          </span>
                          {row.value}
                        </span>
                      )
                    },
                    maxWidth: 100
                  }
                  // {
                  //   Cell: row => (
                  //     <span>
                  //       <Tooltip placement="left" title="Go to this machine's schedule">
                  //         <Icon
                  //           type="export"
                  //           className="fontSize20"
                  //           onClick={() =>
                  //             this.handleScheduleShortcut(
                  //               row.original.schedule_application_id,
                  //               row.original.type
                  //             )
                  //           }
                  //         />
                  //       </Tooltip>
                  //     </span>
                  //   ),
                  //   maxWidth: 35
                  // }
                ]
              }
            ]}
            defaultSorted={[
              {
                id: 'id',
                desc: true
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  leadFollowUpActions: state.leadFollowUpActions,
  userActions: state.userActions,
  auditActions: state.auditActions,
  user: authSelectors.getUser(state, props),
  leadFollowUps: leadFollowUpsSelectors.getLeadFollowUps(state, props),
  followUpIdParam: leadFollowUpsSelectors.getFollowUpIdParam(state, props)
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, followUpActions, userActions, auditActions), dispatch)
})

LeadFollowUps.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeadFollowUps))



// WEBPACK FOOTER //
// ./src/pages/lead/LeadFollowUps.container.js